import { render, staticRenderFns } from "./RelatoriosManutencao.vue?vue&type=template&id=71719db2&scoped=true&"
import script from "./RelatoriosManutencao.vue?vue&type=script&lang=js&"
export * from "./RelatoriosManutencao.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosManutencao.vue?vue&type=style&index=0&id=71719db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71719db2",
  null
  
)

export default component.exports